import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Stack, styled, Typography } from "@mui/material";
import { ButtonWithArrow } from "../common/Button/ButtonWithArrow";
export const HomeContentsLayout = (param)=>{
    let { title , onClick , children  } = param;
    const { isTablet , isMobile  } = useWindowDimensions();
    return /*#__PURE__*/ _jsxs(HomeContentsLayoutContainer, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: isMobile ? "h6" : "h5",
                children: title
            }),
            children,
            /*#__PURE__*/ _jsx(ButtonWithArrow, {
                variant: isTablet ? "strokeSecondary" : "text",
                iconColor: "#6A708A",
                onClick: onClick,
                sx: (theme)=>({
                        marginTop: "12px",
                        color: "#6A708A",
                        fontSize: "16px"
                    }),
                children: "전체보기"
            }, "button")
        ]
    });
};
const HomeContentsLayoutContainer = styled(Stack)((param)=>{
    let { theme  } = param;
    return {
        // padding: '40px 0',
        [theme.breakpoints.down("lg")]: {
            padding: "0 32px 32px 32px"
        },
        [theme.breakpoints.down("sm")]: {
            padding: "0 20px 20px 20px"
        }
    };
});
